import { documentTemplates, gamersTemplates } from '../../../_layout/js/constants_en.js';
import { ajaxUrl, documentsContainer, gamersContainer } from '../../../_layout/js/constants.js';
import '../../../_layout/js/__popover.js';
import handleAdmonParams from '../../../_layout/js/handleAdmonParams.js';
import setDataLink from '../../../_layout/js/setDataLink.js';
import setAppLink from '../../../_layout/js/setAppLink.js';
import tabs from '../../../_layout/js/tabs.js';
import mobileMenu from '../../../_layout/js/mobileMenu.js';

const $documentsContainer = $(documentsContainer);
const $gamersContainer = $(gamersContainer);

$(document).ready(function() {
    $.ajax({
        url: ajaxUrl,
        method: 'GET',
        dataType: 'json', 
        success: function(responseData) {
            if (!responseData?.systemSettings) {
                console.error('Отсутствует systemSettings');
                return null;
            }

            setDataLink(responseData.systemSettings, documentTemplates, $documentsContainer, { position: 'prepend' });
            setDataLink(responseData.systemSettings, gamersTemplates, $gamersContainer, { position: 'after', afterIndex: 0 });
            setAppLink(responseData.systemSettings);
        },
        error: function(error) {
            console.error('Ошибка запроса:', error);
        }
    });

    tabs();
    handleAdmonParams();
    mobileMenu();
});




// WEBPACK FOOTER //
// ./p/program-loyalty-en/src/entry-point.js